// strips # anchor from url
export const stripUrlHash = (url: string): string => {
  const parsedUrl = new URL(url);
  parsedUrl.hash = '';

  return parsedUrl.toString();
};
